import React, { useState, useContext, useEffect  } from "react";
import { AppContext } from "../util/AppContext";
import { useNavigate } from "react-router-dom";
import signOut from "../API/authorization";

function LoginFailureInfoPage () {
	const [appState] = useContext(AppContext);
	const [pageProperties] = useState(appState.config?.Login?.Info);
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useNavigate();
	const defaultMessages = [
		{Value: "<p>It appears that you do not have a territory assignment. Please contact your administrator.</p>"}
		,{Value: "<p>If you believe this is in error, please contact your system administrator. Be sure to include your name, email address, and a brief description of the issue.</p>"}
	];

	function getDialogTitle() {
		return [pageProperties?.Title?.Value || "<h4 className=\"h5 alert-heading\">Account Configuration</h4>"];
	};

	function getBodyContents() {
		let messageElemets = '';

		(pageProperties?.Body || defaultMessages).forEach(element => {
			messageElemets += element.Value;
		});
		return messageElemets;
	}

	useEffect(() => {
		setIsLoading(true);
		logout();
    }, []);

	async function logout() {
		await signOut()
		.then(() => {    
			sessionStorage.clear(); 
		})
		.catch((err) => {
			navigate('/SignOutErrorPage');
		})
		.finally(() => {
			setIsLoading(false);
		});
	}

	return (
		<>
		{!isLoading && <div className="container-xl">
			<div className="row justify-content-center">
				<div className="col-12 col-sm-10 col-md-6">
					<div className="alert alert-info mt-8" role="alert">
						<div className="alert-icon"></div>
						<div className="alert-content">
							<h4 className="h5 alert-heading" dangerouslySetInnerHTML={{ __html: getDialogTitle() }}></h4>
							<p dangerouslySetInnerHTML={{ __html: getBodyContents() }}></p>
						</div>
					</div>
				</div>
			</div>
		</div>}
		</>
	)
}

export default LoginFailureInfoPage